import { render, staticRenderFns } from "./ProgramaTab.vue?vue&type=template&id=0900d3b5&scoped=true"
import script from "./ProgramaTab.vue?vue&type=script&lang=js"
export * from "./ProgramaTab.vue?vue&type=script&lang=js"
import style0 from "./ProgramaTab.vue?vue&type=style&index=0&id=0900d3b5&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0900d3b5",
  null
  
)

export default component.exports